import { Button, Theme, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import MultiHeaderTable from "../../MultiHeaderTable/MultiHeaderTable";
import { TableHeader } from "../../../interfaces";
import SimpleTableBody from "../../MultiHeaderTable/SimpleTableBody";

const useStyles = makeStyles((theme: Theme) => ({
  multiHeaderTableInstProfile: {
    "& thead": {
      "& th, td": {
        textAlign: "left",
      },
    },
    "& tbody": {
      "& td": {
        textAlign: "left",
      },
    },
    "& tr:nth-of-type(even)": {
      backgroundColor: "#e8ecf3",
    },
    "& tr:nth-of-type(odd):hover": {
      backgroundColor: "transparent",
    },
  },
}));

export default function DataAmendments() {
  const classes = useStyles();
  const tableHeadData = [
    { title: "Survey" },
    { title: "Original Release Date" },
    { title: "Last Update*" },
  ];
  const rows = [
    {
      SURVEY: { value: "2024", styles: {} },
      RELEASE: { value: "September 20, 2024", styles: {} },
      UPDATE: { value: " ", styles: {} },
    },
    {
      SURVEY: { value: "2023", styles: {} },
      RELEASE: { value: "September 22, 2023", styles: {} },
      UPDATE: { value: "August 23, 2024", styles: {} },
    },
    {
      SURVEY: { value: "2022", styles: {} },
      RELEASE: { value: "September 16, 2022", styles: {} },
      UPDATE: { value: "August 25, 2023", styles: {} },
    },
    {
      SURVEY: { value: "2021", styles: {} },
      RELEASE: { value: "September 03, 2021", styles: {} },
      UPDATE: { value: "August 15, 2022", styles: {} },
    },
    {
      SURVEY: { value: "2020", styles: {} },
      RELEASE: { value: "September 18, 2020", styles: {} },
      UPDATE: { value: "August 13, 2021", styles: {} },
    },
    {
      SURVEY: { value: "2019", styles: {} },
      RELEASE: { value: "September 13, 2019", styles: {} },
      UPDATE: { value: "August 28, 2020", styles: {} },
    },
    {
      SURVEY: { value: "2018", styles: {} },
      RELEASE: { value: "September 14, 2018", styles: {} },
      UPDATE: { value: "August 16, 2019", styles: {} },
    },
    {
      SURVEY: { value: "2017", styles: {} },
      RELEASE: { value: "October 03, 2017", styles: {} },
      UPDATE: { value: "August 14, 2018", styles: {} },
    },
    {
      SURVEY: { value: "2016", styles: {} },
      RELEASE: { value: "September 30, 2016", styles: {} },
      UPDATE: { value: "October 06, 2017", styles: {} },
    },
    {
      SURVEY: { value: "2015", styles: {} },
      RELEASE: { value: "September 28, 2015", styles: {} },
      UPDATE: { value: "March 15, 2017", styles: {} },
    },
    {
      SURVEY: { value: "2014", styles: {} },
      RELEASE: { value: "September 29, 2014", styles: {} },
      UPDATE: { value: "September 08, 2015", styles: {} },
    },
    {
      SURVEY: { value: "2013", styles: {} },
      RELEASE: { value: "September 30, 2013", styles: {} },
      UPDATE: { value: "September 15, 2014", styles: {} },
    },
    {
      SURVEY: { value: "2012", styles: {} },
      RELEASE: { value: "October 01, 2012", styles: {} },
      UPDATE: { value: "November 18, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2011", styles: {} },
      RELEASE: { value: "October 04, 2011", styles: {} },
      UPDATE: { value: "November 18, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2010", styles: {} },
      RELEASE: { value: "October 07, 2010", styles: {} },
      UPDATE: { value: "November 18, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2009", styles: {} },
      RELEASE: { value: "October 15, 2009", styles: {} },
      UPDATE: { value: "November 04, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2008", styles: {} },
      RELEASE: { value: "October 8, 2008", styles: {} },
      UPDATE: { value: "November 04, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2007", styles: {} },
      RELEASE: { value: "October 11, 2007", styles: {} },
      UPDATE: { value: "November 04, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2006", styles: {} },
      RELEASE: { value: "October 13, 2006", styles: {} },
      UPDATE: { value: "November 04, 2013", styles: {} },
    },
    {
      SURVEY: { value: "2002 - 2005", styles: {} },
      RELEASE: { value: "November 2002 - 2005", styles: {} },
      UPDATE: { value: "November 21, 2013", styles: {} },
    },
    {
      SURVEY: { value: "1997 - 2001", styles: {} },
      RELEASE: { value: "December 1997 - 2001", styles: {} },
      UPDATE: { value: "November 13, 2013", styles: {} },
    },
    {
      SURVEY: { value: "1994 - 1996", styles: {} },
      RELEASE: { value: "December 1996", styles: {} },
      UPDATE: { value: "November 13, 2013", styles: {} },
    },
    {
      SURVEY: { value: "1993 and earlier", styles: {} },
      RELEASE: { value: "Data is not available electronically", styles: {} },
      UPDATE: { value: "", styles: {} },
    },
  ];

  const tableHeaders: TableHeader[][] = [
    tableHeadData.map((value: any) => ({
      title: value.title,
      colSpan: 1,
      styles: {},
    })),
  ];
  return (
    <Router>
      <div className={classes.multiHeaderTableInstProfile}>
        <Typography variant="body2" color="primary">
          The Summary of Deposits (SOD) is the annual survey of branch office
          deposits for all FDIC-insured institutions including insured U.S.
          branches of foreign banks. Data are as of June 30. Users can access
          these data by:
          <ul>
            <li>single institution</li>
            <li>institutions within a geographic area</li>
            <li>aggregated within a geographic area</li>
            <li>
              SOD features include custom market share reports and downloads
            </li>
          </ul>
        </Typography>
        <Typography variant="body2" color="primary">
          Subscribe today for news on future data releases and updates.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          href={`https://service.govdelivery.com/accounts/USFDIC/subscriber/new`}
          target="_blank"
          rel="noopener"
          style={{ width: 240, marginBottom: 32 }}
        >
          Subscribe
        </Button>

        <MultiHeaderTable
          tableHeaders={tableHeaders}
          tableBody={<SimpleTableBody tableData={rows}></SimpleTableBody>}
        />
        <Typography variant="body2" color="primary">
          *Please note: the results of the SOD survey are ‘as reported’ by the
          submitting institutions. Occasionally the FDIC receives amendments to
          the survey. Amendments may include address corrections, county code
          changes, revised zip codes and deposit amounts.
        </Typography>
      </div>
    </Router>
  );
}
